<!--
Copyright (C) Cocouz Oy 2017 - All Rights Reserved 
-->
<template>
  <div class="sidebar__container sidebar__log-out">
    <ul class="sidebar__items">
      <li class="sidebar__item">
        <a :href="lang + '/user/login'"><img src="../assets/img/sidebar/ic_power_settings_new_black_24px.svg" /> Login</a>
      </li>
      <li class="sidebar__item">
        <a :href="lang + '/user/register'"><img src="../assets/img/sidebar/ic_import_contacts_black_24px.svg" /> Register</a>
      </li>
      <li class="sidebar__item">
        <a :href="lang + '/user/register'"><img src="../assets/img/sidebar/ic_star_rate_black_18px.svg" /> List your venue</a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    computed: {
      strings () {
        return this.$store.state.strings
      },
      lang() {
        let lang = this.$store.state.selectedLang;
        if(lang == 'en'){
          lang = '';
        } else {
          lang = '/' + lang;
        }
        return lang;
      }
    }
  }
</script>